// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ol-c";
export var backButton = "_ol-4";
export var backIcon = "_ol-5";
export var chevronShortcut = "_ol-6";
export var container = "_ol-1";
export var editor = "_ol-8";
export var editorWrapper = "_ol-7";
export var prefix = "_ol-2";
export var searchIcon = "_ol-3";
export var suffix = "_ol-9";
export var suffixContent = "_ol-a";
export var suffixText = "_ol-b";
export var wrapper = "_ol-0";